// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"629":"8a995795","919":"2b4ed1ab"}[chunkId] + ".chunk.js";
};